import { io } from 'socket.io-client';

let socket = null;

/**
 * Initialise (or re-initialise) the Socket.IO connection.
 * Safe to call multiple times — disconnects any existing socket first.
 */
export const initSocket = (token = null) => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }

  // In dev, CRA runs on :3000 and backend on :5000. The CRA proxy can't
  // handle socket.io WebSocket upgrades to the Docker-internal hostname
  // (backend:5000). Connect the browser directly to localhost:5000 instead.
  // In production the React build is served by the backend (same origin),
  // so '/' works fine.
  const isDev = window.location.port === '3000';
  const url = isDev
    ? `${window.location.protocol}//${window.location.hostname}:5000`
    : '/';

  socket = io(url, {
    auth: token ? { token } : undefined,
    withCredentials: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
  });

  return socket;
};

/** Returns the active socket, or null if not yet initialised. */
export const getSocket = () => socket;

/** Gracefully close and clear the socket (call on logout). */
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
